import { DateTimeFormatStyle } from "@hopper-i18n/formatter";
import dayjs, { type ConfigType as DayJsInput } from "dayjs";

/**
 * Format dates with support for both locale-aware and legacy formats.
 * @param date - The date to format
 * @param formatDateTime - The i18n formatDateTime function from useI18nContext
 * @param dateFormat - Date format style. Use DateTimeFormatStyle for locale-aware formatting (recommended).
 *                     String format is only for backward compatibility and will not use locale information.
 * @returns Formatted date string
 */
export const formatDateWithLocale = (
  date: DayJsInput | null,
  formatDateTime: (date: Date, format: DateTimeFormatStyle) => string,
  dateFormat?: string | DateTimeFormatStyle
): string => {
  if (!date) return "";

  const finalFormat =
    dateFormat || DateTimeFormatStyle.ShortMonthDayShortWeekday;

  if (typeof finalFormat === "object" && finalFormat) {
    return formatDateTime(dayjs(date).toDate(), finalFormat);
  }

  return dayjs(date).format(finalFormat as string);
};
